export const REDUCER_NAME='resellerSlice';

export interface iResellerResponse {
    id:String,
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    address: string;
    createdAt: string;
    profilePicture:string
}

export interface iResellerState {
    resellerList: iResellerResponse[];
    isLoading: boolean;
    errorMessage: string | null;
}